import { Label } from "../../ToolBox/Label";

import styles from "./SearchFieldContainer.module.scss";

type SearchInputLabelPosition = "top" | "left";

interface ISearchFieldContainerProps {
    /**
     * The optional search field container ID.
     */
    id?: string;

    /**
     * An ID to target in frontend tests.
     */
    dataCy?: string;

    /**
   * The width of the container in pixels.
   */
    width?: string;

    /**
   * Label text: can be positioned on top, left, or omitted.
   */
    label?: string;

    /**
   * Position of the label: 'top' or 'left'.
   */
    labelPosition?: SearchInputLabelPosition;

    /**
   * Children components to render inside the container.
   */
    children: React.ReactNode;
}

/**
 * Reusable container, that handles layout and styling for elements positioning.
 * @param {ISearchFieldContainerProps} param The props used to render the search field container.
 * @returns The rendered component.
 */
function SearchFieldContainer({
    id,
    dataCy,
    width,
    label,
    labelPosition = "top",
    children
}: Readonly<ISearchFieldContainerProps>): JSX.Element {
    const labelPositionStyle = labelPosition === "left" ? styles.labelLeft : styles.labelTop;

    return (
        <div style={{ width }} data-cy={dataCy} className={`${styles.container} ${label ? (labelPositionStyle) : ""}`}>

            {(label && (
                <div className={`${styles.label} ${labelPosition === "left" ? styles.left : styles.top}`}>
                    <Label
                        label={label}
                        htmlFor={id}
                    />
                </div>
            ))}

            <div className={styles.inputWrapper}>
                {children}
            </div>

        </div>
    );
}

export { SearchFieldContainer, SearchInputLabelPosition };
